import React, { useContext } from "react";
import layoutContext from "./layoutContext";
import { HambergerMenu } from "../assets/svg/AllSvg";

const Header = () => {
  const { isAsideOpen, setIsAsideOpen } = useContext(layoutContext);

  return (
    <>
      <header className="sticky top-0 left-0 w-full z-[9]">
        <div className="shadow-md bg-brown h-16 w-full flex justify-between items-center px-4 ">
          <div className="flex gap-2 cursor-pointer">
            <span onClick={() => setIsAsideOpen(!isAsideOpen)}>
              <div className="text-white flex items-center">
                <HambergerMenu size="22" className="mr-3" />
                <p className="text-sm">
                  Yi Wei Athletic Association (Singapore)
                </p>
              </div>
            </span>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
